import PropTypes from 'prop-types';
import React from 'react';

import { PRIMARY_BLUE, WHITE } from '@wetransfer/transfer/constant/colors';

const ArrowUpSolid = ({ fillColor, arrowColor }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8394 7.836C11.4065 10.6783 9.32591 12.0227 6 11.9997C2.67409 12.0227 0.593927 10.6783 0.16062 7.836C0.0560284 7.15083 0 6.57028 0 6C0 5.43277 0.0560284 4.84978 0.16062 4.164C0.59346 1.32169 2.67409 -0.0226802 6 0.000288486C9.32591 -0.0226802 11.4061 1.32169 11.8394 4.164C11.944 4.84917 12 5.42972 12 6C12 6.56784 11.944 7.15083 11.8394 7.836Z"
      fill={fillColor}
    />
    <path
      d="M5.68644 2.72251C5.84799 2.52058 6.15511 2.52058 6.31665 2.72252L8.48296 5.43061C8.72424 5.73223 8.44466 6.16786 8.06994 6.07414L6.09949 5.58129C6.03522 5.56521 5.96798 5.56521 5.90371 5.58128L3.93318 6.07391C3.55847 6.16759 3.27893 5.73197 3.52021 5.43036L5.68644 2.72251Z"
      fill={arrowColor}
    />
    <rect
      x="5.35547"
      y="4.75"
      width="1.29127"
      height="4.84228"
      rx="0.645633"
      fill={arrowColor}
    />
  </svg>
);

ArrowUpSolid.propTypes = {
  fillColor: PropTypes.string,
  arrowColor: PropTypes.string,
};

ArrowUpSolid.defaultProps = {
  fillColor: PRIMARY_BLUE,
  arrowColor: WHITE,
};

export default ArrowUpSolid;
